import React, { memo } from 'react';
import { Card } from 'reactstrap';
import { HTMLService } from '@business/services';
import PerfectScrollbar from 'react-perfect-scrollbar';
import 'react-perfect-scrollbar/dist/css/styles.css';
import { WidgetProps } from '../types';

const LOREM =
  'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Vestibulum ultrices ultrices dui, et dictum diam tincidunt quis. Etiam condimentum vulputate est, id facilisis est ornare id. Etiam viverra sem a mi molestie, ut molestie odio commodo. Nulla hendrerit, libero eu pulvinar aliquet, sapien purus dictum erat, et euismod lectus est sit amet purus. Nulla condimentum lorem et tincidunt aliquam. Nunc dignissim, tortor at pellentesque molestie, sapien ipsum eleifend ex, non pellentesque quam massa eu magna. Suspendisse congue sollicitudin ex, eget facilisis nisl tincidunt ac. Cras aliquam vitae magna eu malesuada. Nullam at euismod ligula. Sed non magna in turpis efficitur luctus. Donec vestibulum, risus vitae gravida aliquet, tellus justo cursus odio, id accumsan ex lectus eget leo. Curabitur iaculis laoreet placerat. Phasellus tempor sed purus nec egestas. Duis eleifend ac mi sed venenatis.';

export const TextWidget = memo((props: WidgetProps<void>) => {
  const { settings } = props;
  return (
    <Card className="p-4" style={{ marginBottom: 0, flex: 1 }}>
      <PerfectScrollbar>
        <div className="d-flex" style={{ flex: 1, flexDirection: 'column' }}>
          <h5 className="text-primary">{settings.title || 'Welcome Back!'}</h5>
          {HTMLService.toReact(settings.description || LOREM)}
        </div>
      </PerfectScrollbar>
    </Card>
  );
});
